import React from "react";
import { MenuItemProps as MuiMenuItemProps } from "@mui/material";
import { MenuItem as MuiMenuItem } from "./menuItem.styles";

export default function MenuItem({ className, ...rest }: MuiMenuItemProps): React.ReactElement {
  return <MuiMenuItem className={`${className ?? ""}`} {...rest} />;
}
